import { render } from "./AppointmentStepConfirm.vue?vue&type=template&id=f9582258"
import script from "./AppointmentStepConfirm.vue?vue&type=script&lang=js"
export * from "./AppointmentStepConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__